export default {"src":"/_next/static/media/partenaLogo.5c5f8315.svg","height":82,"width":225};